/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedModelProductAdminResponse } from '../../models/paged-model-product-admin-response';

export interface GetProductsForAdmin$Params {

/**
 * Filter on name
 */
  name?: string;

/**
 * Filter on brand
 */
  brand?: string;

/**
 * Filter on merchantName
 */
  merchantName?: string;

/**
 * Filter on status
 */
  status?: 'PUBLISHED' | 'DRAFT' | 'REJECTED' | 'ONGOING';

/**
 * Filter based on existence of collectionPackaging
 */
  hasCollectionPackaging?: boolean;

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getProductsForAdmin(http: HttpClient, rootUrl: string, params?: GetProductsForAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProductAdminResponse>> {
  const rb = new RequestBuilder(rootUrl, getProductsForAdmin.PATH, 'get');
  if (params) {
    rb.query('name', params.name, {});
    rb.query('brand', params.brand, {});
    rb.query('merchantName', params.merchantName, {});
    rb.query('status', params.status, {});
    rb.query('hasCollectionPackaging', params.hasCollectionPackaging, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelProductAdminResponse>;
    })
  );
}

getProductsForAdmin.PATH = '/admin/products';
